var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQiwiLogotypeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.659 41.115c2.97 0 6.194 1.025 9.763 4.206.358.318.834-.077.521-.473-3.506-4.455-6.75-5.303-9.984-6.02-3.957-.877-5.992-3.117-7.41-5.576-.282-.49-.409-.403-.434.226-.032.769.022 1.787.193 2.789-.16.006-.32.005-.483.005-5.659 0-10.248-4.617-10.248-10.312 0-5.694 4.59-10.31 10.25-10.31 5.659 0 10.248 4.616 10.248 10.31 0 .406-.02.807-.066 1.2-.748-.137-2.221-.152-3.254-.063-.388.035-.334.217-.04.27 3.388.616 5.715 2.73 6.248 6.562.01.089.127.114.172.038a15.597 15.597 0 0 0 2.194-8.007c0-8.613-6.941-15.598-15.503-15.598C7.264 10.362.323 17.346.323 25.96c0 8.615 6.941 15.6 15.503 15.6 2.27 0 4.526-.445 7.833-.445Zm1.153-5.663c.69.586.9 1.284.536 1.776-.203.27-.532.419-.927.419-.385 0-.758-.136-1.054-.385-.628-.552-.812-1.445-.403-1.953.16-.199.42-.308.732-.308.378 0 .775.16 1.116.45Zm3.183-1.49c.101.683-.113.966-.329.966-.236 0-.53-.277-.878-.824-.345-.54-.47-1.159-.3-1.472.112-.206.348-.297.645-.183.576.218.8 1.105.862 1.512Z",
    fill: "#00ff40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34v55H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQiwiLogotypeGreen);
export default __webpack_public_path__ + "static/media/qiwi-logotype-green.5cf37715bbf4c70547161bcfd364b579.svg";
export { ForwardRef as ReactComponent };